import { BlocksIconSwap } from 'blocks-nextjs/blocks-web-components/components/icon/icons/swap';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSwap = createComponent({ react: React, tagName: 'cat-icon-swap', elementClass: BlocksIconSwap });
